import React from "react";
import {useSelector} from "react-redux";
import {uploadReceipt, submitReceipts, uploadClick, deletePrevUploadedReceipt} from "./redux/codPortalSlice";
import {AppState} from "../../config/redux/reducers";
import BaseUploadReceipt from "../shared/codUploadReceiptBase";
import {createPayloadToDeleteUploadedFile} from "../../mocks/codPortal/response.transforms";

interface CODUploadReceiptProps {
  open: boolean;
  hub: any;
  date: any;
  closePopup: () => void;
}

const CODUploadReceipt = (props: CODUploadReceiptProps) => {
  const {
    draftReceiptData,
    isFileUploaded,
    receiptDataAfterUpload,
    uploadError,
    uploadErrorCode,
    receiptsSubmittedFlag,
    receiptDataAfterSubmit,
    isErrorOnUpload
  } = useSelector((state: AppState) => state.codPortal);

  return (
    <BaseUploadReceipt
      {...props}
      reduxStates={{
        draftReceiptData,
        isFileUploaded,
        receiptDataAfterUpload,
        uploadError,
        uploadErrorCode,
        receiptsSubmittedFlag,
        receiptDataAfterSubmit,
        isErrorOnUpload
      }}
      actions={{
        uploadReceipt,
        submitReceipts,
        uploadClick,
        deletePrevUploadedReceipt
      }}
      transforms={{
        createPayloadToDeleteUploadedFile
      }}
    />
  );
};

export default CODUploadReceipt;